
import { Component, ChangeDetectionStrategy, input, inject } from '@angular/core';
import { TranslateModule, TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-error-msg',
  templateUrl: './error-msg.component.html',
  styleUrls: ['./error-msg.component.scss'],
  changeDetection: ChangeDetectionStrategy.Default,
  standalone: true,
  imports: [
    TranslateModule
]
})
export class ErrorMsgComponent{
  translate = inject(TranslateService);

  readonly errors = input<any>();
  readonly fieldLabel = input<any>();
  readonly secondFieldLabel = input<any>();
  readonly localized = input(true);
  errormsg = '';

}
